var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"container",on:{"click":function($event){_vm.$emit('click')}}},[_c('b-icon',{attrs:{"icon":this.determinedIcon,"size":"is-small"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(this.text || 'Edit'))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23cdd6fb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/EditLink.vue
// module id = null
// module chunks = 